module.exports = __webpack_public_path__ + "media/images/logo-6163883a12e52897fcc4b7326711b193.png";